<template>
    <div class="history-box">
        <el-table :data="tableData" style="width: 100%"
                  @current-change="handleSelectionChange"
        >
            <el-table-column label="" width="30">
                <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.isChecked" @change="checkedClick(scope.row)">&nbsp;</el-checkbox>
                </template>
            </el-table-column>
            <el-table-column prop="create_datetime" label="购买时间" width="160" />
            <el-table-column prop="state" label="状态" width="60">
                <template slot-scope="scope">
                    <span v-if="scope.row.deduct_state">有效</span>
                    <span v-else style="color: #999999">无效</span>
                </template>
            </el-table-column>
            <el-table-column prop="valid_day" label="有效时间" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.valid_day > 0">{{scope.row.expire_datetime}}</span>
                    <span v-else>永久有效</span>
                </template>
            </el-table-column>
            <el-table-column prop="mobile" label="购买人" width="150">
                <template slot-scope="scope">
                    {{scope.row.name}} {{scope.row.mobile}}
                </template>
            </el-table-column>
            <el-table-column prop="count_type" label="卡项类别" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.count_type === '1'">次卡</span>
                    <span v-else-if="scope.row.count_type === '2'">时卡</span>
                    <span v-else-if="scope.row.count_type === '3'">通卡</span>
                </template>
            </el-table-column>

            <el-table-column prop="name" label="名称" show-overflow-tooltip width="180">
                <template slot-scope="scope">
                    <!--<el-tag effect="dark" size="medium">次卡</el-tag>-->
                    {{scope.row.title}}
                    <span v-if="scope.row.count_type !== '2'">( {{scope.row.count_num}}次 )</span>
                </template>
            </el-table-column>
            <el-table-column prop="price" label="售价" width="80" />
            <el-table-column prop="pay_price" label="实付金额" width="80" />
            <el-table-column prop="use_num" label="使用次数" width="80">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleUseView(scope.row)">
                        {{scope.row.use_num}}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column prop="pay_price" label="剩余次数" width="80">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleSurplusView(scope.row)">
                        {{scope.row.surplus_num}}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleEdit(scope.$index, scope.row)">
                        查看权益
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="bottom-box">
            <div class="opt-box">
                <el-button plain @click="setCardValid(false)" :disabled="selectedItem && selectedItem.state==='0'">使失效</el-button>
                <el-button plain @click="setCardValid(true)" :disabled="selectedItem && selectedItem.state==='1'">使有效</el-button>
                <el-button plain @click="editExpireState = true">修改有效期</el-button>
            </div>
            <div class="page-box">
                <el-pagination
                        @size-change="pageSizeChange"
                        @current-change="pageCurrentChange"
                        :current-page="page.nowPage"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.count">
                </el-pagination>
            </div>
        </div>

        <!--权益-->
        <card-sale-history-product v-model="cardProductState" :card-info="cardInfo" />
        <!--修改有效期-->
        <card-edit-expire-time v-model="editExpireState" :selected-card-item="selectedItem" @successEvent="successEvent" />
        <!--使用记录-->
        <store-user-card-use-history v-model="cardUseHistoryState" :card-info="cardInfo"  />
        <!--剩余详情-->
        <store-user-card-surplus-info v-model="cardUseSurplusState" :card-info="cardInfo" />
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import CardSaleHistoryProduct from "@/model/Card/CardSaleHistoryProduct";
    import CardEditExpireTime from "@/model/Card/CardEditExpireTime";
    import StoreUserCardUseHistory from "@/model/StoreUser/StoreUserCardUseHistory";
    import StoreUserCardSurplusInfo from "@/model/StoreUser/StoreUserCardSurplusInfo";
    export default {
        name: "CardSaleHistory",
        components: {StoreUserCardSurplusInfo, StoreUserCardUseHistory, CardEditExpireTime, CardSaleHistoryProduct},
        props: {
            cardId: {
                type: [String, Number],
                default: ""
            },
            startDate: {
                type: String,
                default: ""
            },
            endDate: {
                type: String,
                default: ""
            }
        },
        data: () => ({
            tableData: [],
            page: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
            //权益
            cardProductState: false,
            cardInfo: {},
            //选择的卡项
            selectedItem: null,
            editExpireState: false,
            //状态
            cardUseHistoryState: false,
            cardUseSurplusState: false,
        }),
        methods: {
            //加载数据
            loadHistoryData: function () {
                let postData = {
                    page: this.page.nowPage,
                    limit: this.page.pageSize,
                    card_id: this.cardId,
                    start_date: this.startDate ? this.startDate : "",
                    end_date: this.endDate ? this.endDate : ""
                };
                obj.postData("card/get_sale_history", postData, res => {
                    if(res.errcode === 0){
                        res.data.forEach( val => {
                           val.isChecked = false;
                        });
                        this.tableData = res.data;
                        this.page.count = res.count;
                    }
                });
            }

            //每页显示数量变化
            ,pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadHistoryData();
            }

            //当前页码变化
            ,pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadHistoryData();
            }

            //多选框点击
            ,checkedClick: function (item) {
                if(item.isChecked){
                    this.tableData.forEach( val => {
                        if (val.id !== item.id)
                            val.isChecked = false;
                    });
                    this.selectedItem = item;
                } else {
                    this.selectedItem = {};
                }
            }

            //查看权益
            ,handleEdit: function (index, data) {
                this.cardInfo = data;
                this.cardProductState = true;
            }

            //查看使用记录
            ,handleUseView: function (data) {
                this.cardInfo = data;
                this.cardUseHistoryState = true;
            }

            //查看剩余记录
            ,handleSurplusView: function (data) {
                this.cardInfo = data;
                this.cardUseSurplusState = true;
            }

            //选择改变
            ,handleSelectionChange: function (item) {
                // this.selectedItem = item;
                // this.tableData.forEach( val => {
                //     if (val.id !== item.id)
                //             val.isChecked = false;
                //     else
                //         val.isChecked = true;
                // });
            }

            //使卡无效|有效
            ,setCardValid: function (t) {
                if(obj.isEmpty(this.selectedItem)){
                    obj.message.error("请选择需要修改的卡项");
                    return false;
                }

                let postData = {
                    id: this.selectedItem.id
                };
                let postUrl = t ? "card/set_sale_card_valid" : "card/set_sale_card_invalid";
                obj.postData(postUrl, postData, res => {
                    if(res.errcode === 0){
                        obj.message.success("设置成功");
                        this.loadHistoryData();
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            }

            //设置成功
            ,successEvent: function () {
                this.loadHistoryData();
            }
        },
        watch: {
            cardId: function (val) {
                this.loadHistoryData();
            }
        }
    }
</script>

<style scoped>
    .bottom-box{
        padding-top: 10px;
        display: flex;
        flex-flow: row nowrap;
    }
    .opt-box{
        flex: 1;
        padding: 5px 0;
    }
    .page-box{
        flex: 2;
        text-align: right;
        border-top: none;
    }
</style>
